import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ChaserIndicator } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TableContainer,
  Tooltip,
  Box,
  Typography,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AddChaserIndicatorDetails } from "./AddChaserIndicator";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ViewAndEditEntity } from "./ViewAndEditEntity";
import format from "date-fns/format";
import { commonToast, CommonPaginationContainer } from "../common";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import {
  primaryButtonStyle,
  secondaryButtonStyle,
  submitButtonStyle,
  updateButtonStyle,
  primaryButtonHoverColor,
  primaryBlueColor,
} from "../common/commonButtonStyles";
import "../common/commonPageStyles.css";

// #endregion

export default function ChaserIndicatorContainer() {
  // Selectors
  const classes = useStyles();
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const [row, setRow] = useState([{ green_to_yellow: "", yellow_to_red: "" }]);
  const [tableRows, setTableRows] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [ChaserIndicatorDialog, setChaserIndicatorDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});

  const [validationStatus, setValidationStatus] = useState(true);

  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    page: 1,
    pageSize: 25,
  });

  useEffect(() => {
    if (tableRows?.length >= 5) {
      setPaginationCount(Math.floor(tableRows.length / pageState?.pageSize));
    } else setPaginationCount(0);
  }, [tableRows?.length, pageState?.pageSize]);

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    position: "relative",
  };

  const handleDialogClose = () => {
    setChaserIndicatorDialog(false);
    setEditMode(false);
    setViewMode(false);

    if (!editMode && !viewMode) {
      setRow(
        {
          participating_insurer: "",
        },
      );
      setValidationStatus(true);
    }
    else if (editMode) {
      setValidationStatus(true);
      setCurrentUpdatedFiledsInEditMode({});
    }
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRow = {
      green_to_yellow: "",
      yellow_to_red: ""
    };

    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRow({ ...rowData });
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRow(rowData);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRow(emptyRow);
      setIsCreated(true);
      setChaserIndicatorDialog(true);
    }
    setChaserIndicatorDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };

  const handleReset = () => {
    const emptyRow = {
      green_to_yellow: "",
      yellow_to_red: "",
    };
    setRow(emptyRow);
    setValidationStatus(true);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3, headerAlign: "center" },
    {
      field: "green_to_yellow",
      headerName: "Green to Yellow Duration",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "yellow_to_red",
      headerName: "Yellow to Red Duration",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value?.user_name ?? "-",
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value?.user_name ?? "-",
    },
    {
      field: "updatedDateAndTime",
      headerName: "Last Modified Date",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => format(params?.value, "dd-MM-yyyy") ?? "-",
    },
    ...(userData?.role !== "CC Processor"
      ? [
        {
          field: "actions",
          type: "actions",
          headerName: "Actions",
          flex: 0.8,
          cellClassName: "actions",
          getActions: ({ row }) => {
            let actionsList = [];
            if (UserAuthorisation?.["Edit"] === "Y") {
              actionsList.push(
                <GridActionsCellItem
                  icon={
                    <Tooltip title="Edit">
                      {" "}
                      <EditIcon />{" "}
                    </Tooltip>
                  }
                  label="Edit"
                  className="textPrimary"
                  onClick={() => handleActionButton(row, true)}
                  color="inherit"
                />
              );
            }
            // if (UserAuthorisation?.['Delete'] === "Y") {
            //   actionsList.push(
            //     <GridActionsCellItem
            //       icon={<Tooltip title="Delete"><DeleteIcon /> </Tooltip>}
            //       label="Delete"
            //       onClick={() => handleDeleteClick(row.id)}
            //       color="inherit"
            //     />
            //   );
            // }
            if (UserAuthorisation?.["View"] === "Y") {
              actionsList.push(
                <GridActionsCellItem
                  icon={<VisibilityIcon />}
                  label="view"
                  className="textPrimary"
                  onClick={() => handleActionButton(row, false)}
                  color="inherit"
                />
              );
            }
            return actionsList;
          },
        },
      ]
      : [
        {
          field: "actions",
          type: "actions",
          headerName: "Actions",
          flex: 0.8,
          cellClassName: "actions",
          getActions: ({ row }) => {
            let actionsList = [];

            // if (UserAuthorisation?.['View'] === "Y") {
            actionsList.push(
              <GridActionsCellItem
                icon={<VisibilityIcon />}
                label="view"
                className="textPrimary"
                onClick={() => handleActionButton(row, false)}
                color="inherit"
              />
            );
            // }

            return actionsList;
          },
        }
      ]),
  ];

  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      const resp = await instance.get(ChaserIndicator);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        // const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(resp.data);
      } else {
        setTableRows([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };

  const UserAuthorisation =
    userData?.user_permissions?.permissions_list["Admin Table Maintenance"];

  useEffect(() => {
    loadData();
  }, []);

  const handleInputChange = (colName, value) => {
    const updatedRow = { ...row };

    updatedRow[colName] = value;
    setRow(updatedRow);
    // Edit Mode
    if (editMode) {
      setCurrentUpdatedFiledsInEditMode({
        ...currentUpdatedFiledsInEditMode,
        [colName]: value,
      });
    }
  };
  const validateRow = (row) => {
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (isNaN(row.green_to_yellow) || !Number.isInteger(parseFloat(row.green_to_yellow))) {
      fieldValidations.green_to_yellow = "'Green to Yellow Duration' should be an integer";
    }

    if (
      !row ||
      !row.green_to_yellow ||
      row.green_to_yellow.trim() === ""
    ) {
      fieldValidations.green_to_yellow = "This field is required";
    }

    if (isNaN(row.yellow_to_red) || !Number.isInteger(parseFloat(row.yellow_to_red))) {
      fieldValidations.yellow_to_red = "'Yellow to Red Duration' should be an integer";
    }

    if (
      !row ||
      !row.yellow_to_red ||
      row.yellow_to_red.trim() === ""
    ) {
      fieldValidations.yellow_to_red = "This field is required";
    }
    // Add more validations for other fields...

    setValidationStatus((prevStatus) => {
      const newStatus = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };

  const handleSubmit = async () => {
    // Validate row before submission
    const isRowValid = validateRow(row);

    let editModeObj = {};
    if (editMode) {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.id ?? "";
      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }

    if (!isRowValid) {
      // If row is invalid, stop the submission and display an error
      commonToast("error", "Please fill all required fields.");
      return;
    }

    try {
      let response;
      if (editMode) {
        response = await instance.patch(
          ChaserIndicator + editId + "/",
          editModeObj
        );
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        row.created_by = userData?.id ?? "";

        response = await instance.post(ChaserIndicator, row);
      }

      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };

  return (
    <div style={Container}>
      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Typography variant="h5" className="page-heading">
            Chaser Indicator
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {UserAuthorisation?.["Creation"] === "Y" && (
              <CommonButton
                text="Add"
                handleClick={() => handleActionButton()}
                sx={primaryButtonStyle}
                hoverColor={primaryButtonHoverColor}
                disabled={tableRows.length > 0}
              />
            )}
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "visible",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            paddingBottom: "10px",
            width: "100%",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
          }}
        >
          <DataGrid
            className={classes.pagination}
            loading={isApiCallInprogress}
            rows={tableRows}
            columns={columns}
            rowCount={tableRows?.length}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            pagination
            getRowId={(row) => row?.id}
            autoHeight={false}
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 25}
            pageSizeOptions
            rowsPerPageOptions={[10, 25, 50, 100]}
            onPageSizeChange={(newPageSize) => {
              return setPageState((old) => {
                setPaginationCount(Math.floor((tableRows?.length || 0) / newPageSize));
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            components={{
              Toolbar: () => null,
              NoRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  No Chaser Indicator Records
                </Stack>
              ),
            }}
            sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              width: "100%",
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
                width: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "12px 16px",
                borderBottom: "none",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-row": {
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
                fontSize: "14px",
                color: "#333",
                padding: "12px 16px",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "2px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                minHeight: "48px",
                maxHeight: "48px",
                paddingBottom: "8px",
                paddingTop: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                position: "relative",
                zIndex: 1,
                "& .MuiTablePagination-root": {
                  color: "#666",
                  paddingRight: "16px",
                  margin: 0,
                  minHeight: "32px",
                },
                "& .MuiTablePagination-selectLabel": {
                  fontSize: "13px",
                  margin: 0,
                },
              },
            }}
          />
          <Stack
            style={{
              position: "absolute",
              bottom: "8px",
              right: "16px",
            }}
          >
            <CommonPaginationContainer
              count={paginationCount + 1}
              pageState={pageState}
              setPageState={setPageState}
            />
          </Stack>
        </Box>
      </Box>
      <Dialog
        open={ChaserIndicatorDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            cursor: "default",
            paddingBottom: "0px",
            padding: "20px 24px 16px 24px",
            backgroundColor: "#f8f9fa",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography
              variant="h6"
              sx={{
                color: primaryBlueColor,
                fontWeight: 600,
                fontSize: "18px",
                margin: 0,
              }}
            >
              {viewMode
                ? "View Chaser Indicator"
                : editMode
                  ? "Edit Chaser Indicator"
                  : "Add Chaser Indicator"}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleDialogClose}
              sx={{
                position: "absolute",
                right: 12,
                top: 12,
                color: "#666",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.1)",
                  color: primaryBlueColor,
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "24px" }}
        >
          {isCreated ? (
            <TableContainer sx={{ maxHeight: "300px" }}>
              <AddChaserIndicatorDetails
                handleInputChange={handleInputChange}
                row={row}
                validationStatus={validationStatus}
              />
            </TableContainer>
          ) : (
            <Grid display={"flex"} flexDirection={"column"}>
              <ViewAndEditEntity
                row={row}
                viewMode={viewMode}
                validationStatus={validationStatus}
                editMode={editMode}
                handleInputChange={handleInputChange}
              />
            </Grid>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "flex-end",
            padding: "16px 24px 24px 24px",
            borderTop: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
            gap: "12px",
          }}
        >
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  sx={secondaryButtonStyle}
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                  hoverColor={primaryButtonHoverColor}
                />
              )}
              {editMode && (
                <CommonButton
                  sx={updateButtonStyle}
                  text="Update"
                  handleClick={handleSubmit}
                  disabled={
                    Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0
                  }
                  hoverColor={primaryButtonHoverColor}
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  sx={submitButtonStyle}
                  text="Submit"
                  handleClick={handleSubmit}
                  hoverColor={primaryButtonHoverColor}
                />
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}